<template>
  <div>
    <div class="white-header mobile">
      <el-row class="container">
        <el-col :sm="0" :xs="2">
          <NavMenu
            class="mobile navMenu"
            :config="config"
            :menus="menus"
            :menuClass="menuClass"
          />
        </el-col>
        <el-col :sm="20" :xs="22">
          <el-image
            class="logo"
            fit="contain"
            :src="require('@/assets/images/bjkj/mobile-logo.png')"
          ></el-image>
        </el-col>
        <el-col class="align-right" :sm="4" :xs="0">
          <!-- <Login /> -->
        </el-col>
      </el-row>
    </div>
    <el-image
      class="banner pc"
      fit="cover"
      :src="require('@/assets/images/bjkj/首页-顶部banner.jpg')"
    ></el-image>
     <el-image
      class="banner mobile"
      fit="cover"
      :src="require('@/assets/images/bjkj/mobile-banner.jpg')"
    ></el-image>
  </div>
</template>

<script>
import NavMenu from "@/components/NavMenu.vue";
export default {
  name: "Header",
  props: {
    config: Object,
    menus: Array,
    menuClass: String,
  },
  components: {
    NavMenu
  },
  methods: {
    goPortal() {
      //this.$router.push("/fjkf/portal");
    },
  },
};
</script>

<style scoped>
.white-header {
  height: 60px;
  line-height: 60px;
  background-color: #fff;
  overflow: hidden;
}

.logo {
  max-width: 380px;
  height: 40px;
  vertical-align: middle;
}

.align-right {
  text-align: right;
}

.banner {
  display: block;
  height: 200px;
}

@media (max-width: 767px) {
  .white-header {
    height: 50px;
    line-height: 50px;
    text-align: center;
  }

  .logo {
    margin: auto;
    max-width: 210px;
    height: 22px;
  }

  .banner {
    height: 50px;
  }
  .navMenu {
    padding-left: 0px;
  }
}
</style>
